export const adminFeaturePaths = {
  activationsKeywordsExact: "/optimization/activations/keywords/exact",
  activationsKeywordsOther: "/optimization/activations/keywords/other",
  activationsCampaigns: "/optimization/activations/campaigns",

  liveMonitoring: "/optimization/scraping",
  liveMonitoringAdd: "/admin/features/live-monitoring/add",
  liveBiddingSearchActiveMode: "/optimization/activations/active-mode",
  liveBiddingSearchKoBiddingMaxCpc: "/optimization/activations/ko-bidding/max-cpc",
  liveBiddingSearchKoBiddingTroas: "/optimization/activations/ko-bidding/troas",
  liveBiddingSearchKoBiddingTcpa: "/optimization/activations/ko-bidding/tcpa",
  liveBiddingSearchKoBiddingTargetImpressionShare: "/optimization/activations/ko-bidding/target-impression-share",
  liveBiddingSearchKoBiddingAuto: "/optimization/activations/ko-bidding-auto",
  liveBiddingCampaignBased: "/admin/features/live-bidding/campaign-based",
  liveBiddingAdGroupBased: "/admin/features/live-bidding/ad-group-based",
}; 